import {Injectable} from '@angular/core';
import {Option} from '../classes/option';
import {environment} from '../../environments/environment';
import {Product} from '../classes/product';
import {OptionItem} from '../classes/optionItem';
import {HttpClient, HttpResponse} from '@angular/common/http';

/**
 * Created by strunz on 05.05.2017.
 */
@Injectable()
export class DataService {
    constructor(private http: HttpClient) {
    }

    getOptions(product: String): Promise<any> {
        return this.http.get(environment.api.options + product)
            .toPromise()
            .then((response: HttpResponse<any>) => {
                return response;
            });
    }

    getPrograms(product: String): Promise<any> {
        return this.http.get(environment.api.programs + product)
            .toPromise()
            .then((response: HttpResponse<any>) => {
                return response;
            });
    }

    setOptions(product: String, options: Option[]) {
        this.http.post(environment.api.options + product, options)
            .toPromise()
            .then((response: HttpResponse<any>) => {
                return response;
            });
    }

    compareProducts(a: Product, b: Product) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    compareOptions(a: OptionItem, b: OptionItem) {
        return compareOptions(a, b);
    }

}

function compareOptions(a: OptionItem, b: OptionItem) {
    if (a.subItems.length > 0) {
        a.subItems.sort(compareOptions);
    }
    if (a.label.toLowerCase() < b.label.toLowerCase()) {
        return -1;
    }
    if (a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
    }
    return 0;
}